



















/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var LegoCart = {
    listCartItems: function(){
      var cartItems = [];

      store.forEach(function(key, val) {
        if(key.match("^download_")){
          cartItems.push('<li><span class="cart-item-title">' + val.title + '</span><span class="remove-media" data-src-id="download_' + val.id + '">x entfernen</span></li>');
        }
      });

      // console.log(cartItems.join(''));
      if(cartItems.length > 0){
        $('#item-list').html('<ol>' + cartItems.join('') + '</ol><p class="txt-center"><span id="zip-loader" class="load-spinner hide">ZIP wird erstellt </span> <button id="cart-download" class="btn" href="#"> jetzt runterladen</button></p>');
      }
      else{
        $('#item-list').html('<p class="warning">Es befinden sich noch keine Dateien in der Liste. <br> Sie können welche durch Klick auf das Warenkorbsymbol <i class="icon-cart"></i> beim jeweiligen Artikel/Beitrag hinzufügen</p>');
      }
    }

  };



  $('.media-to-cart').click(function(e){
    // TODO store.enabled Test
    e.preventDefault();
    var dataId = $( this).attr('data-src-id');
    var dataTitle = $( this).attr('data-title');
    store.set('download_' + dataId, { id:  dataId, title: dataTitle  , url: $( this).attr('href') });
  });

  $('#cart').on( 'click', '.remove-media', function(e){
    // console.log('clicked' + $(this));
    store.remove($( this).attr('data-src-id'));

    $( this).parent().hide('slow', function(){
      if( $('#cart').find('li:visible' ).length < 1){
        $('#item-list').html('<p class="warning">Alle Downloads gelöscht</p>');
      }
    });

  });


  $('#cart').on( 'click', '#cart-download', function(e){
    // console.log('clicked' + $(this));
    $(this).attr('disabled', '').addClass('button_loading');


    var cartFiles = store.getAll();

    var request = $.ajax({
      type: 'post',
      async: true,
      url : zm_cart_ajax.ajax_url,
      data : {action: 'zm_create_cart_zip', cartFiles: cartFiles, zipCartNonce: zm_cart_ajax.zipCartNonce}
    });

    request.done(function(data, textStatus) {
      // URL in localstorage speichern mit cart_change_since generate ?

            $('#cart-download').parent().after(data);
      //alert( "Request done: " + data + ' txtStatus ' + textStatus);
            $('#cart-download').removeAttr('disabled').removeClass('button_loading');

    });

    request.fail(function( jqXHR, textStatus ) {
      alert( "Request failed: " + textStatus );
    });

    request.always(function() {
      // alert( "complete" );
    });



  });



















  /*
  FROM HERE SAGE
   */

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // magnific Popup
        $(document).ready(function() {
          $('.media-popup').magnificPopup({type:'image'});

          $('.cart-link').magnificPopup({
            type: 'inline',
            preloader: true,
            // modal: true,
            closeOnContentClick : false,
            closeOnBgClick :true,
            showCloseBtn : true,
              closeBtnInside: true,
            enableEscapeKey : true,

            callbacks: {
              open: function() {
                LegoCart.listCartItems();
              },
              close: function() {
                // Will fire when popup is closed
              }
              // e.t.c.
            }

          });
        });



        if($('#asset-area').length > 0){


          $('#button-media').show();

          $('#button-media').on( 'click', function(){

            var $target = $('#asset-area')

            $('html, body').stop().animate({
              'scrollTop': $target.offset().top
            }, 900, 'swing');
         
          })
        }


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


